/**
 * Helpers para formato Chileno (CLP) - Versión para Base de Datos INTEGER
 */

// 1. Convierte el número (o string con puntos) a "15.000"
export const formatCLP = (value) => {
    if (value === null || value === undefined || value === '') return '';

    // Convertimos a string y quitamos TODO lo que no sea un número
    // (Como ya no hay decimales en la BD, podemos usar \D con seguridad)
    const soloNumeros = String(value).replace(/\D/g, "");

    if (!soloNumeros) return "";

    // Convertimos a entero base 10
    const numeroFinal = parseInt(soloNumeros, 10);

    // Formateamos con puntos de miles (estándar chileno)
    return new Intl.NumberFormat('es-CL').format(numeroFinal);
};

// 2. Convierte "15.000" a 15000 para guardar en la BD (Integer)
export const cleanCLP = (value) => {
    if (!value) return 0;
    // Quitamos los puntos para que a la BD le llegue solo el número
    const limpio = String(value).replace(/\./g, "");
    return parseInt(limpio, 10) || 0;
};